import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useState,
} from 'react';

import { ModalContextModel } from './models/modal-context.model';

export const ModalContext = createContext<ModalContextModel | null>(null);

const ModalContextProvider: FunctionComponent = (
  props: PropsWithChildren<Record<string, unknown>>
) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [component, setComp] = useState<JSX.Element | null>(null);

  const modalStateHandler = (): void => {
    setIsOpen(prevState => !prevState);
  };

  const componentHandler = (comp: JSX.Element | null): void => {
    setComp(comp);
  };

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        component,
        componentHandler,
        modalStateHandler,
      }}
    >
      {props.children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
